/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";

import { useGLTF } from "@react-three/drei";
import {
  metalicDarkMaterial,
  woodMaterial,
} from "../../../../common/materials";

const model = "/models/desk/desk.glb";

export default function Desk({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF(model);

  //useFrame((state, delta) => (woodMaterial.current.uTime += delta));

  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-2.85, 0.51, 2.3]} rotation={[Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.desk_3.geometry}
          // material={materials["wood-table"]}
          material={woodMaterial}
        />

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.desk_4.geometry}
          material={metalicDarkMaterial}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.desk_5.geometry}
          material={metalicDarkMaterial}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.drawer2.geometry}
        material={metalicDarkMaterial}
        position={[-1.8, 0.68, 2.23]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.drawer3.geometry}
        material={metalicDarkMaterial}
        position={[-1.8, 0.45, 2.23]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.drawer1.geometry}
        material={metalicDarkMaterial}
        position={[-1.8, 0.9, 2.23]}
      />
    </group>
  );
}

useGLTF.preload(model);
